import { tenderAIAPi } from './tender-ai-api';
import { convertModelToFormDataWithFileData } from './helpers';
const createProposal = (proposal) => {
    const formData = convertModelToFormDataWithFileData(proposal);
    var result = tenderAIAPi.postForm(`proposal/`, formData);
    return result;
};
const getProposals = (companyId) => {
    const url = companyId && companyId !== 'ALL' ? `proposal?companyId=${companyId}` : 'proposal/';
    console.log('API Request URL:', url, 'CompanyId:', companyId);
    return tenderAIAPi.get(url);
};
const getDocumentProcessStatus = () => {
    return tenderAIAPi.get(`proposal/GetDocumentProcessStatus`);
};
const deleteProposal = (id) => {
    return tenderAIAPi.put(`proposal/${id}`);
};
const getClauses = (proposalId) => {
    return tenderAIAPi.get(`proposal/${proposalId}/clauses`);
};
const getAnalysis = (proposalId) => {
    return tenderAIAPi.get(`Proposal/${proposalId}/analysis`);
};
const rollbackClauseAnswer = (proposalId, clauseId, questionId, versionId) => {
    return tenderAIAPi.post(`proposal/${proposalId}/clauses/${clauseId}/questions/${questionId}/rollback/${versionId}`);
};
const ProposalApi = {
    createProposal,
    getProposals,
    getDocumentProcessStatus,
    deleteProposal,
    getClauses,
    getAnalysis,
    rollbackClauseAnswer
};
export default ProposalApi;
